module.exports = __webpack_public_path__ + "lato-thin-italic-16d14ad314296a4644d550c8f20bd407.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-thin-italic/lato-thin-italic.woff
// module id = 1041
// module chunks = 0